import { render } from "./PaymentInProgress.vue?vue&type=template&id=fdf08f3e"
import script from "./PaymentInProgress.vue?vue&type=script&lang=js"
export * from "./PaymentInProgress.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__